import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { currentEnv } from './env-util';

const ENABLED_ENVS = ['prod', 'staging'];

let initialized = false;

const initRum = () => {
  const env = currentEnv();
  if (initialized || !ENABLED_ENVS.includes(env)) {
    return;
  }

  datadogRum.init({
    applicationId: '3f57d26a-df2f-4950-bf3e-f6d31dd98bf6',
    clientToken: 'pubb88086a8096fd68761f3d5d9cec05b85',
    site: 'datadoghq.com',
    service: 'cloud-campaign-web',
    env,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    allowedTracingUrls: [window.location.origin],
    traceSampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogLogs.init({
    clientToken: 'pubb88086a8096fd68761f3d5d9cec05b85',
    site: 'datadoghq.com',
    service: 'cloud-campaign-web',
    env,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['warn'],
    sessionSampleRate: 100,
  });

  initialized = true;
};

const reportEvent = (name, meta) => {
  if (initialized) {
    datadogRum.addAction(name, meta);
  }
};

const reportError = (error, meta) => {
  if (initialized) {
    const err = error instanceof Error ? error : new Error(error);
    datadogRum.addError(err, meta);
  }
};

const setUser = (user) => {
  if (initialized) {
    datadogRum.setUser(user);
    datadogLogs.setUser(user);
  }
};

const startView = (name) => {
  if (initialized) {
    datadogRum.startView({ name });
  }
};

export { initRum, reportEvent, reportError, setUser, startView };
